export default __webpack_public_path__ + "20580fb2ef102041329bdaee6f678477.jpg";